module.exports = __webpack_public_path__ + "media/images/orange-5339255ffcd6d6db32f6bcfc5a3cde82.jpg";